module.exports = require('./lib/linkify-string').default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/linkifyjs/string.js
// module id = 1131
// module chunks = 3